@let filesValue = files();

@if (filesValue.length) {
  <rt-attachments-list
    [attachments]="filesValue"
    [deletable]="true"
    [canManageCandidates]="true"
    [small]="true"
    (deleteClick)="onRemoveFile($event)"
    margin-bottom-small-x
  />
}

@if (preview()) {
  <rt-button class="file-field__upload" variant="outline" [disabled]="true">
    <rt-icon name="file-upload" margin-right-small-x />
    {{ 'app.evaluation_panel.upload_file' | translate }}
  </rt-button>
} @else {
  <rt-button
    class="file-field__upload"
    variant="outline"
    [loading]="isUploading()"
    [disabled]="isUploading()"
    (click)="openFilePicker()"
  >
    <rt-icon name="file-upload" margin-right-small-x />
    {{ 'app.evaluation_panel.upload_file' | translate }}
  </rt-button>

  <rt-file-handler [multiple]="true" [validateMaxSize]="true" (nextFile)="onNextFile($event)" />
}
